import React, { useState, useEffect } from 'react'
import { Alert, Button, ButtonGroup, Container, Card, Col, Form, Row, Modal, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import CustomNavbar from '../../components/CustomNavbar';
//import SidebarDashboard from '../../components/SidebarDashboard';
import CustomTable from '../../components/CustomTable';
import CustomPagination from '../../components/CustomPagination';
import { getCurrentSituation, saveCurrentSituation, editCurrentSituation, deleteCurrentSituation } from '../../redux/currentSituation/actions';

import messages from '../../redux/messages';
import SidebarConfig from '../../components/SidebarConfig';

const CurrentSituation = props => {

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState('');
  //const [loadingType, setLoadingType] = useState('initial');
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const data = useSelector(store => store.currentSituation.currentSituation);
  const dataLenght = useSelector(store => store.currentSituation.currentSituationLength);
  const pages = Math.ceil(dataLenght / limit);
  const loading = useSelector(store => store.currentSituation.loading);
  const saveLoading = useSelector(store => store.currentSituation.saveLoading);
  

  const columns = [
    {
      Header: 'Codigo',
      accessor: 'codigo'
    },
    {
      Header: 'Descripción',
      accessor: 'descripcion'
    },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div 
        className="btn-group" 
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
            <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
      </div>)
    }
  ];

  // Métodos
  useEffect(() => {
    dispatch(getCurrentSituation({
      offset: offset,
      limit: limit,
      filter: filter
    }, parseInt(props.match.params.type)));
  }, [dispatch, offset, limit, filter, props.match.params.type]);

  const addArea = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    setValidated(false);
  }

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    setValidated(false);
  }

  /*Paginación*/
  const prev = () => {
    if(currentPage <= 0)
      setCurrentPage(0);
    else
      setCurrentPage(currentPage - 1);

    setOffset(offset - limit);
  }

  const next = () => {
    if (currentPage >= pages)
      setCurrentPage(pages);
    else
      setCurrentPage(currentPage + 1);
    
    setOffset(offset + limit);
  }

  const last = () => {
    setCurrentPage(pages);
    setOffset((pages * limit) - limit);
  }

  const first = () => {
    setCurrentPage(1);
    setOffset(0);
  }

  const onChangeLimit = value => {
    setLimit(parseInt(value));
    setOffset(0);
    setCurrentPage(1);
  };
  /*fin paginación*/

  const onSearch = e => {
    e.preventDefault();
    if(!e.target.inputSearch.value.trim()){
      return;
    }
    setFilter(e.target.inputSearch.value);
    //setLoadingType('initial');
    // dispatch(getCurrentSituation({
    //   offset: offset,
    //   limit: limit,
    //   filter: filter
    // }));
  }

  const onSubmitInstitutes = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    
    const req = {
      codigo: e.target.codigo.value,
			descripcion: e.target.descripcion.value,
    };

    if(!edit){
      dispatch(saveCurrentSituation(req, parseInt(props.match.params.type)));
      e.target.reset();
      setShowModal(false);
    }else{
      dispatch(editCurrentSituation(req, editItem.id, index, parseInt(props.match.params.type)));
      setShowModal(false);
    }
  }

  const seeAll = () => setFilter('');

  const onDelete = (id, index) => {
    if(window.confirm(messages.preguntaEliminar)){
      dispatch(deleteCurrentSituation(id, index, parseInt(props.match.params.type)));
    }
  }
  
  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">Situación actual</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                  id="inputSearch"
                  name="inputSearch"
                  //onChange={ e => setFilter(e.target.value)}
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type="search"></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle">
                      <i className="material-icons">visibility</i>
                    </Button>
                    <Button 
                      variant="light" 
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addArea()}><i className="material-icons">add</i></Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : data.length > 0 ? (
              <> 
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={data} />
                  </Card.Body>
                </Card>
                <CustomPagination 
                  limit={limit}
                  offset={offset}
                  currentPage={currentPage}
                  dataLenght={dataLenght}
                  pages={pages}
                  prev={ prev }
                  next={ next }
                  first={ first }
                  last={ last }
                  onChangeLimit={onChangeLimit} />
              </>
            ) : (
              <Alert variant="info" className="my-4">
                Aún no hay situación actual, comienza agregando algunos
              </Alert>
            )
          }
        </Container>
      </div>
      <Modal 
        show={showModal}
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmitInstitutes} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar situación actual' : 'Crear situación actual'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row} className="mb-3">
              <Form.Label 
                column 
                sm="12"
                md="4">Código</Form.Label>
              <Col 
                sm="12"
                md="8">
                <Form.Control
                  name="codigo"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={ edit ? editItem.codigo : null}
                  // onChange={()=> onBlurValidateFormat()}
                  pattern="[A-Za-z0-9]+"
                  placeholder="Código"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números y letras
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label 
                column 
                sm="12"
                md="4">Descripción</Form.Label>
              <Col 
                sm="12"
                md="8">
                <Form.Control
                  name="descripcion"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={ edit ? editItem.descripcion : null}
                  // pattern="[a-zA-Z][a-zA-Z\s]*"
                  pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$"
                  placeholder="Nombre de unidad"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite letras
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"  
              variant="secondary" 
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveLoading}  
              variant="primary" 
              type="submit">
                {
                  saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  )
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default CurrentSituation
